import { Licensing } from '@adaptiva/core/licensing';
import { Pipe, PipeTransform } from '@angular/core';
import { IProductTrialDisplay } from '../interfaces';

@Pipe({ name: 'adaAiProductTrialText' })
export class AiProductTrialTextPipe implements PipeTransform {

	public transform(_product: IProductTrialDisplay): string {
		switch (_product.state) {
			case Licensing.States.ENABLED:
				return 'Active';
			case Licensing.States.ENABLING:
				return 'Activating';
			case Licensing.States.DISABLED:
			case Licensing.States.DISABLING:
			case Licensing.States.REMOVING:
			case Licensing.States.FAILED:
			case Licensing.States.NOT_AVAILABLE:
				return 'Trial unavailable';
			case Licensing.States.NOT_PRESENT:
				return 'Trial available';
			default:
				return 'Product state unknown';
		}
	}

}
